import React from 'react';
import { Target } from 'lucide-react';
import clsx from 'clsx';
import { ProjectScoping } from '../../types';
import { SectionHeader } from './SectionHeader';

interface IntentSectionProps {
    intent: ProjectScoping['intent'];
    isDark: boolean;
    canEdit: boolean;
    onEdit: () => void;
}

export const IntentSection: React.FC<IntentSectionProps> = ({ intent, isDark, canEdit, onEdit }) => (
    <div className={clsx('p-4 rounded-lg border', isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200')}>
        <SectionHeader icon={Target} colorClass="text-purple-500" title="1. InTent (Project Goals & Scope)" onEdit={onEdit} canEdit={canEdit} isDark={isDark} />
        <div className="space-y-3">
            <div>
                <div className="text-sm font-medium text-slate-500 mb-1">Goals</div>
                <ul className="list-disc list-inside space-y-1 text-sm">
                    {intent.goals.map((goal, idx) => (
                        <li key={idx} className={isDark ? 'text-slate-300' : 'text-slate-700'}>{goal}</li>
                    ))}
                </ul>
            </div>
            <div>
                <div className="text-sm font-medium text-slate-500 mb-1">Scope Boundaries</div>
                <p className={clsx('text-sm', isDark ? 'text-slate-300' : 'text-slate-700')}>{intent.scopeBoundaries}</p>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <div className="text-sm font-medium text-slate-500 mb-1">Assumptions</div>
                    <ul className="list-disc list-inside space-y-1 text-sm">
                        {intent.assumptions.map((assumption, idx) => (
                            <li key={idx} className={isDark ? 'text-slate-300' : 'text-slate-700'}>{assumption}</li>
                        ))}
                    </ul>
                </div>
                {intent.exclusions && (
                    <div>
                        <div className="text-sm font-medium text-slate-500 mb-1">Exclusions</div>
                        <ul className="list-disc list-inside space-y-1 text-sm">
                            {intent.exclusions.map((exclusion, idx) => (
                                <li key={idx} className={isDark ? 'text-slate-300' : 'text-slate-700'}>{exclusion}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    </div>
);
